export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/realistic-pattern.b8c7619.svg";